import React, { Component } from "react";
import { Modal } from "react-bootstrap";

import ContactForm from "./ContactForm";

import mixpanel from "mixpanel-browser";

import './content/content.css';

class ContactModal extends Component {

	constructor(props) {
		super(props);
		this.fa = this.fa.bind(this);
		this.mixpanel = mixpanel;
	}

	fa() {
		return this.props.fa ? this.props.fa : "fa-envelope-open-o";
	}

	componentWillReceiveProps(props) {
		if (this.props.visible !== props.visible) {

			const label = props.visible ? 'Opened' : 'Closed';

	        this.mixpanel.track("Contact Form " + label, {
	        	list: props.topic,
	        	cue: props.contactModalCue,
	        	push: props.contactModalPush,
	        	lastNameVisible: props.lastNameVisible,
	        	messageInputCollapsed: props.messageInputCollapsed
	        });
	    }
	}

	render() {

		const topic = this.props.topic ? this.props.topic : "Contact Us";		

        return (
            <div className="static-modal">
                <Modal show={this.props.visible} className="contact-modal">
                    <Modal.Header closeButton={true} onHide={this.props.handleHide}>
                    </Modal.Header>

                    <Modal.Body>

                        <h3 className="text-center">
                            <i
                                className={"fa fa-3x " + this.fa()}
                                aria-hidden="true"
                            />
                        </h3>
						<h2 className="text-center">{topic}</h2>
						<h4 className="text-center">{this.props.contactModalCue}</h4>
						<h5 className="text-center">{this.props.contactModalPush}</h5>
                    	<ContactForm lastNameVisible={false} list={this.props.topic}
                    		handleHide={this.props.handleHide}
                    		messageInputCollapsed={this.props.messageInputCollapsed}
                    		topic={this.props.topic}
                    		contactModalCue={this.props.contactModalCue}
                    		contactModalPush={this.props.contactModalPush}
                    	/>

                    </Modal.Body>

                    <Modal.Footer className="text-center">
                    	<a href="mailto:sales@webfinery.com" className="btn bt-default">sales@webfinery.com</a>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default ContactModal;


// WEBPACK FOOTER //
// ./src/ContactModal.js